import { render, staticRenderFns } from "./EhrNavListItem.vue?vue&type=template&id=503db08d&scoped=true&lang=pug"
import script from "./EhrNavListItem.vue?vue&type=script&lang=js"
export * from "./EhrNavListItem.vue?vue&type=script&lang=js"
import style0 from "./EhrNavListItem.vue?vue&type=style&index=0&id=503db08d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503db08d",
  null
  
)

export default component.exports